import script from "./Popularize.vue?vue&type=script&lang=ts&setup=true"
export * from "./Popularize.vue?vue&type=script&lang=ts&setup=true"

import "./Popularize.vue?vue&type=style&index=0&id=4bcf096a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bcf096a"]])

export default __exports__